import React from 'react';
import ReactDOM from 'react-dom';
import FilteredListing from '.';

const renderFilteredListing = () => {
    const listingApp = document.getElementById('js-listing-app');

    if (!listingApp) {
        return;
    }

    const configName = listingApp.dataset.config;

    if (!configName) {
        return;
    }

    const props = {
        configName
    };

    ReactDOM.render(
        React.createElement(FilteredListing, props, null),
        listingApp
    );
};

renderFilteredListing();
